import { GATrackingEvent } from '../ga-tracking-event.model';
import { GATrackingEventPayload } from '../ga-tracking-event-payload.model';
import { GaTrackingEventAction, GaTrackingEventName, GATrackingEventType } from '../../constants';
import { Product } from '~shared/models';

import get from 'lodash.get';

export class GATrackingPlpPromotionClickEvent implements GATrackingEvent {
  constructor(private product: Product,
              private pageName: string,
              private index: number,
              private searchTerm?: string,
              private label?: string) {}

  getEventType(): GATrackingEventType {
    return GATrackingEventType.PromotionClick;
  }

  getPayload(): GATrackingEventPayload {
    const promoTracking = {
      ecommerce: {
        promoClick: {
          actionField: {
            list: this.pageName,
          },
          promotions: [
            {
              id: get(this.product, 'id'), // Name or ID is required
              name: get(this.product, 'name'),
              format: 'promoted product',
              creative: '',
              position: this.index + 1,
            },
          ],
        },
      },
      dimension56: this.searchTerm
    };

    return {
      event: GaTrackingEventName.PromoClick,
      gtmCustom: promoTracking,
      label: this.label
    };
  }
}
